import { useMutation, useQueryClient } from "@tanstack/react-query";
import { createCourse as createCourseApi } from "@/services/dashboard/apiCourses";
import toast from "react-hot-toast";

function useCreateCourse() {
    const queryClient = useQueryClient();

    const {
        mutate: createCourse,
        isLoading: isCreating,
        error,
    } = useMutation({
        mutationFn: createCourseApi,

        onSuccess: () => {
            queryClient.invalidateQueries({
                queryKey: ["coursesDashboard"],
            });

            toast.success("تم أنشاء الكورس بنجاح");
        },

        onError: (error) => {
            toast.error(error.response.data.message);
        },
    });

    return { createCourse, isCreating, error };
}

export default useCreateCourse;
